import Card from '../Card';
import React from 'react';
import Utils from '../../services/utils/utils';
import {__, STR_KEY} from '../../services/Translate';
import BookSessions from '../BookSessions';
import {
    GeckoBtn,
    GeckoModalService,
    GeckoModal
} from '@geckolabs/gecko-react-ui';

const bookSessionsFn = (event) => {
    return new GeckoModalService().open(() => {
        return (
            <GeckoModal className="modal-session-single">
                <BookSessions backButton={() => bookSessionsFn()} event={event} />
            </GeckoModal>
        );
    }, {labelledBy: "searchLabel"});
};

const BookSessionsBtn = ({event}) => {
    return (
        <Card className="book-sessions-btn-container">
            <GeckoBtn
                id="book-sessions"
                name={__(STR_KEY.BTN_BOOK_SESSIONS)}
                icon="list"
                handler={() => { 
                    // Do not remove the parent brackets, this is an accessibility change
                    // that will focus on the original element after the modal is closed
                    bookSessionsFn(event) 
                }} />
        </Card>
    );
};

export default BookSessionsBtn;